import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DigiServiceService } from '../services/digi-service.service';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { DigiAlertPopupComponent } from '../digi-alert-popup/digi-alert-popup.component';
import { DigiReportPopupComponent } from '../digi-report-popup/digi-report-popup.component';
import { DigiAnalysisComponent } from '../digi-analysis/digi-analysis.component';
import { Subscription, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
interface FuelMetrics {
  fuelUsedPercent: number;     // total % consumed (ignores refills)
  fuelUsedLitres: number;
  fuelPerKWh: number;          // litres per kWh
  fuelCost: number;            // rupees spent
  kwhperliter:number;
  refillCount: number;
}
@Component({
  selector: 'app-digi-monitoring',
  templateUrl: './digi-monitoring.component.html',
  styleUrls: ['./digi-monitoring.component.scss']
})
export class DigiMonitoringComponent implements OnInit, OnDestroy {
  // Math reference for template
  Math = Math;

  // Selected device (object with deviceid, digiid, sitename)
  selectedDevice: any = null;

  // Data & info
  currentData: any = null;
  generatorInfo: any = null;
  generatorIds: any[] = [];

  // Metrics
  metrics: any = {
    KWH: 0,
    KVAH: 0,
    KVARH: 0,
    PF: 0,
    runningHours: 0,
    energyEfficiency: 0,
    loadFactor: 0,
    fuelRatePerKWh: 0,
    totalFuel: 0,
    fuelUnitPrice: 0
  };

  // Totals for analytics tab
  totalGenerators = 0;
  onlineGenerators = 0;
  offlineGenerators = 0;
  alertGenerators = 0;
  totalAlerts = 0;
  activeWarnings = 0;

  // Filters
  timeOptions: string[] = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  timeFilter: string = 'Today';         // used by HTML analytics tab
  selectedDuration: any = 'Today';      // used by logic / live tab
  customeSelectedDate: any = null;
  selectedFilter: any = null;

  // status & flags
  connectionStatus: 'connected' | 'disconnected' | 'syncing' = 'connected';
  lastUpdate = new Date();
  lastStart = new Date();
  isData = false;

  // Oil gauge config
  oilTempMin = 0;
  oilTempMax = 100;
  oilGaugeCircumference = Math.PI * 80; // used in template
fuelDataObject:any;
  // timers / subscriptions
  private connectionTimer: any = null;
  private subs: Subscription = new Subscription();

  // current user
  currentUserData: any = JSON.parse(localStorage.getItem('userData') || '{}');
  deviceStatus: any = {"online":0,"offline":0};
  utilizationStatus: string;

  constructor(
    private digiService: DigiServiceService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
  ) {}

  ngOnInit(): void {
    this.getDigiIds();
    this.startConnectionSimulation();
  }

  ngOnDestroy(): void {
    this.stopAllTimers();
    this.subs.unsubscribe();
  }

  // ---------------------------
  // Helpers to replace ?. and ??
  // ---------------------------

  /**
   * Return first non-null/undefined value among possible keys of an object.
   * Example: getAny(obj, ['KWH','kwh'], 0)
   */
   getAny(obj: any, keys: string[], defaultValue: any) {
    if (!obj) return defaultValue;
    for (let i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (obj[k] !== undefined && obj[k] !== null) {
        return obj[k];
      }
    }
    return defaultValue;
  }

  /**
   * Safe access: returns obj[prop] if obj exists and prop is not null/undefined else defaultVal
   */
  private safe(obj: any, prop: string, defaultVal: any) {
    if (!obj) return defaultVal;
    var v = obj[prop];
    return (v !== undefined && v !== null) ? v : defaultVal;
  }

  private getSelectedDeviceId(): any {
    return (this.selectedDevice && this.selectedDevice.deviceid) ? this.selectedDevice.deviceid : null;
  }

  // ===========================
  // Data fetching methods
  // ===========================

  getDigiIds(): void {
    if (!this.currentUserData || !this.currentUserData.userid) {
      // fallback - no user info
      this.generatorIds = [];
      this.updateTotals();
      return;
    }

    const s = this.digiService.getDigiIds({ userid: this.currentUserData.userid })
      .pipe(
        catchError(err => {
          console.error('getDigiIds error', err);
          return of({ status: false, result: [] });
        })
      )
      .subscribe((resp: any) => {
        if (resp && resp.status && Array.isArray(resp.result)) {
          this.generatorIds = resp.result;
          this.totalGenerators = this.generatorIds.length;
          this.getGeneratorsStatus(this.generatorIds)
          // try to derive status if available inside description JSON (best-effort)
          this.deriveDeviceStatuses();

          // select first device by default
          if (this.generatorIds.length > 0) {
            this.selectedDevice = this.generatorIds[0];
            this.onDeviceSelect(this.selectedDevice);
          } else {
            this.selectedDevice = null;
            this.currentData = null;
            this.isData = false;
          }
        } else {
          this.generatorIds = [];
          this.updateTotals();
        }
      });

    this.subs.add(s);
  }
getGeneratorsStatus(generatorsIds:any){
  console.log("asjdhasjdsa",generatorsIds)
this.digiService.getDeviceStatus(generatorsIds).subscribe(res=>{
  if(res.status){
    console.log("online devices",res.result)
    this.deviceStatus.offline = generatorsIds.length - res.result.length;
    this.deviceStatus.onliine = res.result.length;
  } else {
    this.deviceStatus.offline = generatorsIds.length;
  }
})
}
  // Best-effort: derive counts from description JSON if present.
  private deriveDeviceStatuses(): void {
    var online = 0, offline = 0, alert = 0;

    for (var i = 0; i < this.generatorIds.length; i++) {
      var d = this.generatorIds[i];
      try {
        if (d && d.description) {
          var desc = (typeof d.description === 'string') ? JSON.parse(d.description) : d.description;
          var st = (desc && desc.status) ? (desc.status + '').toLowerCase() : null;
          if (st === 'online') online++;
          else if (st === 'offline') offline++;
          else if (st === 'alert' || st === 'warning') alert++;
          else online++; // unknown treated as online
        } else {
          online++;
        }
      } catch (err) {
        online++;
      }
    }

    this.onlineGenerators = online;
    this.offlineGenerators = offline;
    this.alertGenerators = alert;
  }

  getDeviceInfo(deviceid: string): void {
    if (!deviceid) return;
    const s = this.digiService.getGeneratorByDeviceid({ deviceid })
      .pipe(catchError(err => {
        console.error('getGeneratorByDeviceid error', err);
        return of({ status: false });
      }))
      .subscribe((res: any) => {
        if (res && res.status) {
          this.generatorInfo = res.result;
        } else {
          this.generatorInfo = null;
        }
      });
    this.subs.add(s);
  }

  getData(deviceObject: any): void {
    if (!deviceObject || !deviceObject.deviceid) return;
    const s = this.digiService.getDigiLastData({ deviceid: deviceObject.deviceid })
      .pipe(catchError(err => {
        console.error('getDigiLastData error', err);
        return of({ status: false });
      }))
      .subscribe((res: any) => {
        if (res && res.status && res.result && res.result.length) {
          // result[0].readings is JSON string
          try {
            this.currentData = JSON.parse(res.result[0].readings);
          } catch (err) {
            this.currentData = res.result[0].readings;
          }
          // attach metadata if present
          this.currentData.insertedDate = res.result[0].insertedDate || this.currentData.Date || new Date().toISOString();

          // set defaults if missing keys used by template -- using getAny helper
          this.currentData.Fuel_Level = this.getAny(this.currentData, ['Fuel_Level', 'fuelLevel'], 0);
          this.currentData.refuelAt = this.getAny(this.currentData, ['refuelAt'], 20);
          this.currentData.RPM = this.getAny(this.currentData, ['RPM', 'rpm'], 0);
          this.currentData.Oil_Temp = this.getAny(this.currentData, ['Oil_Temp', 'oilTemp'], 0);
          this.currentData.L1_Voltage = this.getAny(this.currentData, ['L1_Voltage', 'l1Voltage'], 0);
          this.currentData.L2_Voltage = this.getAny(this.currentData, ['L2_Voltage', 'l2Voltage'], 0);
          this.currentData.L3_Voltage = this.getAny(this.currentData, ['L3_Voltage', 'l3Voltage'], 0);
          this.currentData.L1L2_Voltage = this.getAny(this.currentData, ['L1L2_Voltage', 'l1l2Voltage'], 0);
          this.currentData.L2L3_Voltage = this.getAny(this.currentData, ['L2L3_Voltage', 'l2l3Voltage'], 0);
          this.currentData.L3L1_Voltage = this.getAny(this.currentData, ['L3L1_Voltage', 'l3l1Voltage'], 0);
          this.currentData.L1_Current = this.getAny(this.currentData, ['L1_Current', 'l1Current'], 0);
          this.currentData.L2_Current = this.getAny(this.currentData, ['L2_Current', 'l2Current'], 0);
          this.currentData.L3_Current = this.getAny(this.currentData, ['L3_Current', 'l3Current'], 0);
          this.currentData.PF = this.getAny(this.currentData, ['PF', 'powerFactor'], 1);
          this.currentData.Total_KW = this.getAny(this.currentData, ['Total_KW', 'totalKW'], 0);
          this.currentData.Total_KVA = this.getAny(this.currentData, ['Total_KVA', 'totalKVA'], 0);
          this.currentData.Total_KVAR = this.getAny(this.currentData, ['Total_KVAR', 'totalKVAR'], 0);
          this.currentData.KWH = this.getAny(this.currentData, ['KWH', 'kwh'], 0);
          this.currentData.KVARH = this.getAny(this.currentData, ['KVARH', 'kvarh'], 0);
          this.currentData.KVAH = this.getAny(this.currentData, ['KVAH', 'kvah'], 0);

          this.isData = true;

          // update device status based on currentData thresholds
          this.updateDeviceStatus();
        } else {
          this.currentData = null;
          this.isData = false;
        }
      });
    this.subs.add(s);
  }

  // ===========================
  // UI handlers (selection & filter)
  // ===========================

  // Called from template when device is selected
  onDeviceSelect(device?: any): void {
    // template may pass event.value or nothing; allow both
    var dev = (device !== undefined && device !== null) ? device : this.selectedDevice;
    if (!dev) return;

    this.selectedDevice = dev;
    this.getDeviceInfo(dev.deviceid);
    this.getData(dev);

    // maintain the currently selected duration
    var tf = (this.selectedDuration !== undefined && this.selectedDuration !== null) ? this.selectedDuration : this.timeFilter;
    tf = (tf !== undefined && tf !== null) ? tf : 'Today';
    this.filters(tf);
  }

  // filters() is used by your HTML (analytics tab) and Live Data section
  filters(duration: any): void {
    this.selectedDuration = duration;
    // precompute device id safe
    var deviceid = this.getSelectedDeviceId();

    // If custom open dialog
    if (duration === 'Custom') {
      const dialogRef = this.dialog.open(CustomDateComponent, {
        autoFocus: false,
        height: '350px',
        width: '450px',
        data: { details: '', action: 'Add', selectedDate: this.customeSelectedDate }
      });

      dialogRef.afterClosed().subscribe(value => {
        if (value) {
          // Object spread is fine in TS 3.5; if you face issues replace with Object.assign
          this.selectedFilter = Object.assign({}, value, { duration: duration, deviceid: deviceid });
          this.customeSelectedDate = value;
        } else {
          // user closed without selecting — keep previous filter
          this.selectedFilter = { duration: duration, deviceid: deviceid };
        }
        if (this.selectedFilter && this.selectedDevice) {
          this.getReportData(this.selectedFilter);
          // pass deviceid (safe)
          if (deviceid) this.getDeviceInfo(deviceid);
        }
      });
    } else {
      this.selectedFilter = { duration: duration, deviceid: deviceid };
      if (this.selectedFilter && this.selectedDevice) {
        this.getReportData(this.selectedFilter);
        if (deviceid) this.getDeviceInfo(deviceid);
      }
    }
  }

  // ===========================
  // Report & metrics logic
  // ===========================

  getReportData(filter: any): void {
    if (!filter || !filter.deviceid) return;
    this.ngxLoader.startLoader('analytics');

    const s = this.digiService.getReportData(filter)
      .pipe(catchError(err => {
        console.error('getReportData error', err);
        return of({ status: false });
      }))
      .subscribe(async (res: any) => {
        if (res && res.status && Array.isArray(res.result) && res.result.length > 1) {
          var data = res.result;
          // compute differences between first and last per existing logic
          try {
            var first = data[0];
            var last = data[data.length - 1];

            var kwh = Number(this.getAny(last, ['KWH', 'kwh'], 0)) - Number(this.getAny(first, ['KWH', 'kwh'], 0));
            var kvah = Number(this.getAny(last, ['KVAH', 'kvah'], 0)) - Number(this.getAny(first, ['KVAH', 'kvah'], 0));
            var kvarh = Number(this.getAny(last, ['KVARH', 'kvarh'], 0)) - Number(this.getAny(first, ['KVARH', 'kvarh'], 0));

            this.metrics.KWH = Number(kwh.toFixed(2));
            this.metrics.KVAH = Number(kvah.toFixed(2));
            this.metrics.KVARH = Number(kvarh.toFixed(2));
            this.metrics.energyEfficiency = (this.metrics.KVAH ? Number((this.metrics.KWH / this.metrics.KVAH).toFixed(2)) : 0);
            this.metrics.runningHours = await this.calculateRunningHours(data);
            this.metrics.loadFactor = await this.calculateLoadFactor(data);
            this.fuelDataObject =  await  this.calculateFuelMetrics(data,this.generatorInfo.fuelTankCapacity,this.metrics.KVAH,Number(this.generatorInfo.fuelPrice));
            
            
            this.ngxLoader.stopLoader('analytics');
          } catch (err) {
            this.ngxLoader.stopLoader('analytics');
            console.error('calc metrics error', err);
            this.resetMetrics();
          }
        } else {
          this.ngxLoader.stopLoader('analytics');
          this.resetMetrics();
        }
      });

    this.subs.add(s);
  }

  resetMetrics(): void {
    this.metrics = {
      KWH: 0,
      KVAH: 0,
      KVARH: 0,
      PF: 0,
      runningHours: 0,
      energyEfficiency: 0,
      loadFactor: 0,
      fuelRatePerKWh: 0,
      totalFuel: 0,
      fuelUnitPrice: 0
    };
  }

  calculateFuelMetrics(
    fuelData:any,
    tankCapacity: number,
    energyGeneratedKWh: number,
    fuelRatePerLitre: number
  ): FuelMetrics {
    if ( fuelData.length < 2 || tankCapacity <= 0) {

      return { fuelUsedPercent: 0, fuelUsedLitres: 0, fuelPerKWh: 0, fuelCost: 0, refillCount: 0,kwhperliter:0 };
    }

    // Sort by time ascending (safety)
    //fuelData.sort((a, b) => new Date(a.insertedDate).getTime() - new Date(b.insertedDate).getTime());
    console.log("asasdasdasdwad",tankCapacity)
    let totalFuelUsedPercent = 0;
    let refillCount = 0;

    // Start baseline as first reading
    let lastLevel = Number(fuelData[0].Fuel_Level);
    if (Number.isNaN(lastLevel)) lastLevel = 0;

    // tolerance to ignore tiny jitter (e.g., 0.2% noise). Adjust as needed.
    const TOLERANCE = 0.2;

    for (let i = 1; i < fuelData.length; i++) {
      const currentLevelRaw = Number(fuelData[i].Fuel_Level);
      if (Number.isNaN(currentLevelRaw)) {
        // skip invalid reading
        continue;
      }
      console.log("fuelData[i].Fuel_Level",fuelData[i].Fuel_Level)
      const currentLevel = currentLevelRaw;

      const diff = lastLevel - currentLevel;

      if (diff > TOLERANCE) {
        // genuine consumption
        totalFuelUsedPercent += diff;
        lastLevel = currentLevel; // move baseline forward
      } else if (currentLevel - lastLevel > 2) {
        // level increased => refill (or sensor jump). Treat as refill: don't add consumption.
        refillCount++;
        lastLevel = currentLevel; // reset baseline to the new higher value
      } else {
        // difference within tolerance => noise; ignore and keep lastLevel unchanged or set to current
        // set to current so we follow small trends (optional)
        lastLevel = currentLevel;
      }
    }

    // Convert percent used -> litres
    const fuelUsedLitres = (totalFuelUsedPercent / 100) * tankCapacity;

    // fuel per kWh and cost
    const fuelPerKWh = energyGeneratedKWh > 0 ? fuelUsedLitres / energyGeneratedKWh : 0;
    const fuelCost = fuelUsedLitres * fuelRatePerLitre;
    let kwhperliter:any = 0;
    if(fuelUsedLitres != 0){
      kwhperliter = Number(energyGeneratedKWh/fuelUsedLitres).toFixed(2);
    }
    return {
      fuelUsedPercent: Number(totalFuelUsedPercent.toFixed(2)),
      fuelUsedLitres: Number(fuelUsedLitres.toFixed(2)),
      fuelPerKWh: Number(fuelPerKWh.toFixed(4)),
      fuelCost: Number(fuelCost.toFixed(2)),
      kwhperliter:kwhperliter,
      refillCount
    };
  }
 
   
  

  // ===========================
  // Calculations used in template
  // ===========================

  calculateLoadFactor(data: any[]): number {
    if (!data || data.length === 0 || !this.generatorInfo.capacity) return 0;

    // Helper to safely get numeric average for a key
    const avg = (key: string): number => {
      const values = data
        .map(d => Number(this.getAny(d, [key], 0)))
        .filter(v => !isNaN(v));
      if (values.length === 0) return 0;
      return values.reduce((a, b) => a + b, 0) / values.length;
    };

    // ✅ Compute averages
    const Vavg =
      (avg('L1L2_Voltage') + avg('L2L3_Voltage') + avg('L3L1_Voltage')) / 3;
    const Iavg =
      (avg('L1_Current') + avg('L2_Current') + avg('L3_Current')) / 3;
    const PFavg = Math.abs(avg('PF'));

    console.log('Averages → Vavg:', Vavg, 'Iavg:', Iavg, 'PF:', PFavg);

    // ✅ Compute total power in kW
    const PtotalKW = (Math.sqrt(3) * Vavg * Iavg * PFavg) / 1000;

    // ✅ Load factor calculation
    const capacity = Number(this.generatorInfo.capacity);
    if (!capacity || capacity === 0) return 0;

    const loadFactor = PtotalKW / capacity;

    return Number(isFinite(loadFactor) ? loadFactor.toFixed(2) : 0);
  }

  calculateRunningHours(data: any[]): number {
    if (!Array.isArray(data) || data.length === 0) return 0;

    var sorted = data.slice().sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime());
    var totalMinutes = 0;
    for (var i = 1; i < sorted.length; i++) {
      var prev = sorted[i - 1];
      var curr = sorted[i];

      var diffMs = new Date(curr.Date).getTime() - new Date(prev.Date).getTime();
      var diffMinutes = diffMs / (1000 * 60);

      var prevRunning = Number(this.getAny(prev, ['Total_KW', 'TotalKW', 'Total_KW'], 0)) > 0;
      var currRunning = Number(this.getAny(curr, ['Total_KW', 'TotalKW', 'Total_KW'], 0)) > 0;

      // as per original logic — counting gaps up to 20 minutes
      if (prevRunning && currRunning && diffMinutes <= 20) {
        totalMinutes += diffMinutes;
      }
    }
    let time = Number((totalMinutes / 60).toFixed(2));
    if( time > 15 && (this.selectedDuration == "Today" || this.selectedDuration == "Yesterday")){
      this.utilizationStatus = "Overutilized"
    } else if(time < 1 && (this.selectedDuration == "Today" || this.selectedDuration == "Yesterday")){
      this.utilizationStatus = "Underutilized"
    } else if(this.selectedDuration == "Today" || this.selectedDuration == "Yesterday") {
      this.utilizationStatus = "Optimal"
    }
    if(time > 80 && this.selectedDuration == "This Week" ){
      this.utilizationStatus = "Overutilized"
    } else if(time < 5 && this.selectedDuration == "This Week"){
      this.utilizationStatus = "Underutilized"
    } else if(this.selectedDuration == "This Week") {
      this.utilizationStatus = "Optimal"
    }
    if( time > 200 && (this.selectedDuration == "This Month" || this.selectedDuration == "Last Month")){
      this.utilizationStatus = "Overutilized"
    } else if(time < 10 && (this.selectedDuration == "This Month" || this.selectedDuration == "Last Month")){
      this.utilizationStatus = "Underutilized"
    } else if(this.selectedDuration == "This Month" || this.selectedDuration == "Last Month") {
      this.utilizationStatus = "Optimal"
    }
    
    return Number((totalMinutes / 60).toFixed(2));
  }

  // ===========================
  // Helper visual / status methods (used by HTML)
  // ===========================

  getFuelGaugeHeight(): number {
    var val = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
    return Math.max(2, Math.min(98, val));
  }

  getFuelColorClass(): string {
    var val = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
    if (val > 50) return 'fuel-high';
    if (val > 30) return 'fuel-medium';
    return 'fuel-low';
  }

  shouldShowRefuelWarning(): boolean {
    var level = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
    var refAt = Number(this.getAny(this.currentData, ['refuelAt'], 20));
    return level <= refAt;
  }

  getRPMDashOffset(): number {
    var minRPM = 500;
    var maxRPM = 2000;
    var rpm = Number(this.getAny(this.currentData, ['RPM', 'RPM'], 0));
    var percentage = Math.max(0, Math.min(1, (rpm - minRPM) / (maxRPM - minRPM)));
    var full = 534; // same as template stroke-dasharray
    return full - (full * percentage);
  }

  getVoltageStatus(voltage: number, type: 'l1' | 'l2' | 'l3' | 'l1l2' | 'l2l3' | 'l3l1'): string {
    if (voltage == null || isNaN(voltage)) return 'normal';
    var min = 0, max = 999;
    switch (type) {
      case 'l1':
      case 'l3':
        min = 55; max = 65;
        break;
      case 'l2':
        min = 24; max = 28;
        break;
      case 'l1l2':
      case 'l3l1':
        min = 28; max = 32;
        break;
      case 'l2l3':
        min = 4; max = 6;
        break;
      default:
        min = 0; max = 999;
    }

    if (voltage < min || voltage > max) return 'critical';
    if (voltage < min * 1.05 || voltage > max * 0.95) return 'warning';
    return 'normal';
  }

  getCurrentStatus(current: number): string {
    if (current == null || isNaN(current)) return 'normal';
    if (current > 30) return 'high';
    if (current < 2) return 'low';
    return 'normal';
  }

  getOilTempStatus(): string {
    var val = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));
    if (val > 95) return 'critical';
    if (val > 90) return 'warning';
    if (val < 60) return 'low';
    return 'normal';
  }

  getOilTempDashOffset(): number {
    var value = Math.max(this.oilTempMin, Math.min(this.oilTempMax, Number(this.getAny(this.currentData, ['Oil_Temp'], 0))));
    var percentage = (value - this.oilTempMin) / (this.oilTempMax - this.oilTempMin);
    return this.oilGaugeCircumference * (1 - percentage);
  }

  getPowerFactorStatus(): string {
    var pf = Number(this.getAny(this.currentData, ['PF'], 1));
    if (pf < 0.7) return 'low';
    if (pf < 0.8) return 'warning';
    return 'normal';
  }

  getConnectionStatusText(): string {
    switch (this.connectionStatus) {
      case 'connected': return 'Connected';
      case 'disconnected': return 'Disconnected';
      case 'syncing': return 'Syncing...';
      default: return 'Unknown';
    }
  }

  formatDate(date: any): string {
    if (!date) return 'N/A';
    try {
      var d = new Date(date);
      return d.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (err) {
      return String(date);
    }
  }

  getParameterStatus(parameter: string, value: number): string {
    switch (parameter) {
      case 'fuelLevel':
        if (value <= 15) return 'critical';
        if (value <= 30) return 'warning';
        return 'normal';
      case 'rpm':
        if (value > 1800 || value < 1000) return 'critical';
        if (value > 1700 || value < 1200) return 'warning';
        return 'normal';
      case 'oilTemp':
        return this.getOilTempStatus();
      case 'powerFactor':
        return this.getPowerFactorStatus();
      default:
        return 'normal';
    }
  }

  getSystemHealth(): number {
    var healthScore = 100;
    if (!this.currentData) return healthScore;

    if (this.currentData.status === 'alert') healthScore -= 30;
    else if (this.currentData.status === 'warning') healthScore -= 15;

    var fuel = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
    if (fuel < 20) healthScore -= 20;
    else if (fuel < 50) healthScore -= 10;

    var rpm = Number(this.getAny(this.currentData, ['RPM'], 0));
    if (rpm > 1700) healthScore -= 15;

    var oil = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));
    if (oil > 90) healthScore -= 15;

    var pf = Number(this.getAny(this.currentData, ['PF'], 1));
    if (pf < 0.8) healthScore -= 10;

    return Math.max(0, Math.min(100, healthScore));
  }

  // imbalance & vunbalance helpers
  getInbalance(currentData: any) {
    var L1 = Number(this.getAny(currentData, ['L1_Current'], 0));
    var L2 = Number(this.getAny(currentData, ['L2_Current'], 0));
    var L3 = Number(this.getAny(currentData, ['L3_Current'], 0));
    var avg = (L1 + L2 + L3) / 3 || 1;
    var max = Math.max(L1, L2, L3);
    var min = Math.min(L1, L2, L3);
    var imbalancePercent = ((max - min) / avg) * 100;
    return {
      imbalancePercent: parseFloat(isFinite(imbalancePercent) ? imbalancePercent.toFixed(2) : '0'),
      status: imbalancePercent > 20 ? 'High Imbalance' : 'Normal'
    };
  }

  getVunbalance(currentData: any) {
    var L1 = Number(this.getAny(currentData, ['L1_Voltage'], 0));
    var L2 = Number(this.getAny(currentData, ['L2_Voltage'], 0));
    var L3 = Number(this.getAny(currentData, ['L3_Voltage'], 0));
    var avg = (L1 + L2 + L3) / 3 || 1;
    var deviations = [Math.abs(L1 - avg), Math.abs(L2 - avg), Math.abs(L3 - avg)];
    var maxDeviation = Math.max.apply(null, deviations);
    var vunbalancePercent = (maxDeviation / avg) * 100;
    return {
      vunbalancePercent: parseFloat(isFinite(vunbalancePercent) ? vunbalancePercent.toFixed(2) : '0'),
      status: vunbalancePercent > 2 ? 'High Unbalance' : 'Normal'
    };
  }

  // ===========================
  // Status simulation & timers
  // ===========================

  startConnectionSimulation(): void {
    this.connectionTimer = setInterval(() => {
      this.simulateConnectionStatus();
    }, 30000);
  }

  stopAllTimers(): void {
    if (this.connectionTimer) {
      clearInterval(this.connectionTimer);
      this.connectionTimer = null;
    }
  }

  simulateConnectionStatus(): void {
    var random = Math.random();
    if (random > 0.9) {
      this.connectionStatus = 'disconnected';
      setTimeout(() => {
        this.connectionStatus = 'syncing';
        setTimeout(() => {
          this.connectionStatus = 'connected';
        }, 2000);
      }, 3000);
    }
  }

  updateDeviceStatus(): void {
    if (!this.currentData) return;
    var fuel = Number(this.getAny(this.currentData, ['Fuel_Level'], 0));
    var rpm = Number(this.getAny(this.currentData, ['RPM'], 0));
    var l1 = Number(this.getAny(this.currentData, ['L1_Voltage'], 0));
    var oil = Number(this.getAny(this.currentData, ['Oil_Temp'], 0));

    if (fuel <= 10 || rpm > 1800 || l1 < 50 || l1 > 70 || oil > 95) {
      this.currentData.status = 'alert';
    } else if (fuel <= this.getAny(this.currentData, ['refuelAt'], 20) || rpm > 1650 || l1 < 55 || l1 > 65 || oil > 90) {
      this.currentData.status = 'warning';
    } else {
      this.currentData.status = 'online';
    }
  }

  // ===========================
  // Dialog / navigation helpers
  // ===========================

  goToAlerts(): void {
    this.dialog.open(DigiAlertPopupComponent, {
      width: '80%',
      height: '90%',
      data: { deviceId: this.selectedDevice }
    });
  }

  goToReports(): void {
    this.dialog.open(DigiReportPopupComponent, {
      width: '80%',
      height: '95%',
      data: { deviceData: this.currentData }
    });
  }

  goToAnalysis(): void {
    this.dialog.open(DigiAnalysisComponent, {
      width: '80%',
      height: '92%',
      data: { deviceData: this.currentData }
    });
  }

  // small util to update totals (fallback)
  private updateTotals(): void {
    this.totalGenerators = this.generatorIds.length;
    // if no per-device status we assume they are online to avoid showing zeros
    this.onlineGenerators = this.generatorIds.length;
    this.offlineGenerators = 0;
    this.alertGenerators = 0;
  }
}
